<template>
	<div class="modal fade" id="new-attribute" tabindex="-1" role="dialog" aria-labelledby="new-attribute" style="padding-right: 15px; overflow-y: scroll;" aria-modal="true">
		<!-- <span class="help-block error">{{this.errors.formError}}</span> -->
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<form @submit.prevent="sendAttribute" enctype="multipart/form-data" novalidate>
					<div class="block block-rounded block-themed block-transparent mb-0">
						<div class="block-header bg-primary-dark">
							<h3 class="block-title" v-if="newAttribute">
								<i class="fa fa-pencil-alt mr-1"></i> 
								Create a new {{title}}
							</h3>
							<div class="block-options">
								<button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close">
									<i class="fa fa-fw fa-times"></i>
								</button>
							</div>
						</div>
						<div class="block-content">
							<div class="form-group">
								<label for="message-msg">Name</label>
								<span class="help-block error">{{this.errors.name}}</span>
								<input type="text" class="form-control" v-model="attribute.name">
							</div>
							<div class="form-group">
								<label for="message-msg">Sub Title</label>
								<span class="help-block error">{{this.errors.name}}</span>
								<input type="text" class="form-control" v-model="attribute.sub_title">
							</div>
							<div class="form-group">
								<label for="message-msg">Description</label>
								<span class="help-block error">{{this.errors.description}}</span>
								<textarea class="form-control form-control-alt" id="message-msg" name="message" rows="6" v-model="attribute.description"></textarea>
							</div>
							
						</div>
						<div class="block-content block-content-full text-right border-top">
							<button type="button" class="btn btn-alt-primary mr-1" data-dismiss="modal" id="close-new-message">Cancel</button>
							<button type="submit" class="btn btn-primary" :disabled="isUpdating">
								Create
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		newAttribute: {
			type: Boolean
		},
	},
	data: () => {
		return {
			title: "ATTRIBUTE",
			errors: [],
			attribute: {
				name: '',
				sub_title: '',
				description: ''
			},
			partner_id: window.bwPartnerId,
			uploadError: null,
			currentStatus: null,
			valid: false,
			isUpdating: false,
			isInitial: true
		}
	},
	methods: {
		async sendAttribute(parentId) {
			if(this.validate()) {
				this.isUpdating = true

				document.getElementById("close-new-message").click()
				try {
					await axios.post(`/attributes`, this.attribute).then(res => {
						this.isUpdating = false
						this.$emit('get-attributes')
						this.$emit('add-attribute', res.data, true)
						let timerInterval
						Bandwango.helpers('swal', {
							title: 'Your attribute is being created...',
							html: 'Enjoy your day!',
							timer: 2500,
							timerProgressBar: true,
							didOpen: () => {
								Bandwango.helpers('swal').showLoading()
								timerInterval = setInterval(() => {
									const content = Bandwango.helpers('swal').getContent()
									if (content) {
										const b = content.querySelector('b')
										if (b) {
											b.textContent = Bandwango.helpers('swal').getTimerLeft()
										}
									}
								}, 100)
							},
							willClose: () => {
								clearInterval(timerInterval)
							}
						})
					})
					this.attribute.name = ''
					this.attribute.description = ''
					this.attribute.sub_title = ''
					
				}
				catch(error) {
					let timerInterval
					Bandwango.helpers('swal', {
						title: 'Something went wrong:',
						html: 'Try again or talk to an admin if the error continues.',
						timer: 2500,
						timerProgressBar: true,
						didOpen: () => {
							Bandwango.helpers('swal').showLoading()
							timerInterval = setInterval(() => {
								const content = Bandwango.helpers('swal').getContent()
								if (content) {
									const b = content.querySelector('b')
									if (b) {
										b.textContent = Bandwango.helpers('swal').getTimerLeft()
									}
								}
							}, 100)
						},
						willClose: () => {
							clearInterval(timerInterval)
						}
					})
					console.error(error)
				}
			}
			else {
				console.log("validation error...");
			}
			this.attribute.message = ''
			this.attribute.subject = ''
		},
		validate() {
			this.errors = [];
			if(!this.attribute.name) {
				this.errors['messageError'] = 'This Field Cannot be Empty.';
			}
			
			if (Object.keys(this.errors).length === 0) {
				this.valid = true
				return true;
			}
			return false
		},
	},
	mounted() {
	}
}
</script>

<style lang="scss">

	.error {
		color: red;
		font-weight: bold;
	}


</style>
